import React, { Fragment } from 'react';
import { connect } from 'react-redux';
// import { Query } from 'react-apollo';
// import { PORTAL_STATUS_QUERY } from 'src/components/Pages/Orders/graphql';
import { Field } from 'react-final-form';


function StatusSelect({ operatorId }) {
    const variables = {
        operatorId
    };
    const translated_status = {
        "UNCLASSIFIED": "Não clasificado",
        "SEARCH": "Consulta",
        "VEHICLE_NOT_FOUND": "Veículo não encontrado",
        "VEHICLE_WITHOUT_DEBTS": "Veículo sem débitos",
        "SERVICE_UNAVAILABLE": "Serviço indisponivel",
        "SIMULATION": "Simulação",
        "PENDING": "Pendente",
        "PAYMENT_INITIATED": "Pagamento Iniciado",
        "CHECKOUT_SUCCESS": "Finalizado",
        "CHECKOUT_FAIL": "Falhou",
        "CANCELLED": "Cancelado",
        "BARCODE_EMITTED": "Código de barras emitido",
        "CHARGEBACK": "Estornado"
    }
    return (
        <Field
            name="status"
            component="select"
            className="form-control form-control-alternative"
        >
            <option />
            {[
                "CANCELLED",
                "CHECKOUT_FAIL",
                "CHECKOUT_SUCCESS",
                "PAYMENT_INITIATED",
                "SEARCH",
                "SERVICE_UNAVAILABLE",
                "SIMULATION",
                "VEHICLE_NOT_FOUND",
                "VEHICLE_WITHOUT_DEBTS",
                "UNCLASSIFIED",
                "PENDING",
                "BARCODE_EMITTED",
                "CHARGEBACK",
            ].map(status => (
                <option
                    key={status}
                    value={status}
                >
                    {translated_status[status] ? translated_status[status] : status}
                </option>
            ))}
            {/* <Query query={PORTAL_STATUS_QUERY} variables={variables}>
                {({ loading, error, data }) => {
                    if (loading || error) return <Fragment />;
                    const { statusList } = data.portalOrders;
                    const options = statusList.map(status => (
                        <option
                            key={status}
                            value={status}
                        >
                        {translated_status[status] ? translated_status[status] : status}
                        </option>
                    ));
                    return options;
                }}
            </Query> */}
        </Field>
    );
}

const mapStateToProps = (state) => ({
    operatorId: state.session.operatorId
});

export default connect(mapStateToProps)(StatusSelect);



// WEBPACK FOOTER //
// ./src/components/Pages/Orders/Filters/StatusSelect.js